// import
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// lib
import { Typing } from "./_libs/Typing";
import SplitText from "./_libs/SplitText";
import { debounce } from "./_utils/Utils";

document.addEventListener("DOMContentLoaded", () => {
  new SplitText(".js-title-target", {
    target: ".js-title-text",
    transition: [90],
  });
  gsap
    .timeline()
    .add(
      () =>
        document.querySelector(".js-fv-background").classList.add("is-active"),
      "+=0.1",
    )
    .to(".js-fv-item", {
      filter: "blur(0px) brightness(1)",
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
      stagger: 0.2,
    })
    .add(
      () =>
        document
          .querySelectorAll(".js-title-target")
          .forEach((el) => el.classList.add("is-active")),
      "-=0.1",
    )
    .to(
      ".js-fv-text",
      {
        opacity: 1,
        duration: 1,
        ease: "power4.out",
      },
      "<",
    );

  // タイピング(横書き)
  Typing(".js-typing-effect", 0.015);

  // トリガーアイテム要素を全て取得
  const triggerItems = document.querySelectorAll(".js-trigger-item");
  // ドット要素を全て取得
  const dotItems = document.querySelectorAll(".js-dot-item");

  // アクティブなドットを更新する関数
  function updateActiveDot(dataNumber) {
    // 全てのドットからis-currentクラスを削除
    dotItems.forEach((dot) => {
      dot.classList.remove("is-current");
    });

    // 対応するdata-numberのドットにis-currentクラスを追加
    const targetDot = document.querySelector(
      `.js-dot-item[data-number="${dataNumber}"]`,
    );
    if (targetDot) {
      targetDot.classList.add("is-current");
    }
  }

  // 各トリガーアイテムにScrollTriggerを設定
  triggerItems.forEach((item) => {
    const dataNumber = item.getAttribute("data-number");

    ScrollTrigger.create({
      trigger: item,
      start: "top top", // エリアの上端が画面中央に来た時
      end: "bottom center", // エリアの下端が画面中央を過ぎた時
      onEnter: () => {
        // エリアに入った時
        updateActiveDot(dataNumber);
      },
      onEnterBack: () => {
        // 逆方向からエリアに入った時（上スクロール）
        updateActiveDot(dataNumber);
      },
      // デバッグ用マーカー（開発時のみ使用）
      // markers: true,
      // id: `trigger-${dataNumber}`
    });
  });

  const debouncedScrollTriggerRefresh = debounce(() => {
    ScrollTrigger.refresh(true);
  }, 300);
  window.addEventListener("resize", debouncedScrollTriggerRefresh);
});

window.addEventListener("load", () => {});
